import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.chatbot');
import { AfterViewInit, ElementRef, HostListener, OnDestroy, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { chatSession } from "src/libs/portal/fab/chat-session";
import { ETCH_SCENARIO_ID, ETCH_SCENARIO_SCREENS, publicFloatingChatCompletion } from "src/libs/portal/fab/etch-scenario";
import { publicDesktopChatCompletion } from "src/libs/portal/fab/desktop-handoff";
import { ChatEmbedBridge } from "src/libs/portal/season/util/chat-embed";

const CHANNEL = 'nanofab.floating-chat';

@Component({
    selector: 'wiz-page-chatbot',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.chatbot/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 0;
  --history-bg: #fff;
  --history-surface: #f7f9fc;
  --history-selected: #eaf2ff;
  --history-border: #d9e1ec;
  --history-text: #0f172a;
  --history-muted: #64748b;
  --history-accent: #2563eb;
  --history-error: #b42318;
}

:host-context([data-theme=dark]) {
  --history-bg: #101c30;
  --history-surface: #16243b;
  --history-selected: #1c3557;
  --history-border: #30415b;
  --history-text: #e5edf8;
  --history-muted: #a5b5cb;
  --history-accent: #8ab7ff;
  --history-error: #ff9b9b;
}

.nf-chatbot-root, .nf-chatbot-content {
  position: relative;
  height: 100%;
  min-height: 0;
  min-width: 0;
}

.nf-chatbot-root.is-history-docked {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 340px;
}

.nf-chatbot-content wiz-portal-fab-chat {
  display: block;
  height: 100%;
  min-height: 0;
}

.nf-history-overlay {
  position: absolute;
  inset: 0;
  z-index: 30;
  overflow: hidden;
}

.nf-history-overlay.is-docked {
  position: relative;
  inset: auto;
  z-index: auto;
  height: 100%;
  min-height: 0;
  min-width: 0;
}

.nf-history-backdrop {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  padding: 0;
  border: 0;
  background: rgba(15, 23, 42, 0.35);
}

.nf-history-drawer {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  width: min(100%, 360px);
  min-height: 0;
  color: var(--history-text);
  background: var(--history-bg);
  border-left: 1px solid var(--history-border);
  box-shadow: -8px 0 28px rgba(15, 23, 42, 0.15);
  font-size: 13px;
}

.nf-history-drawer.is-docked {
  position: relative;
  inset: auto;
  width: 100%;
  height: 100%;
  box-shadow: none;
}

.nf-history-drawer button, .nf-history-drawer input {
  font: inherit;
}

.nf-history-drawer button {
  min-height: 32px;
  cursor: pointer;
  border: 1px solid var(--history-border);
  border-radius: 9px;
  padding: 6px 10px;
  background: var(--history-bg);
  color: var(--history-text);
}

.nf-history-drawer button:disabled {
  cursor: default;
  opacity: 0.45;
}

.nf-history-drawer button:focus-visible, .nf-history-drawer input:focus-visible {
  outline: 2px solid var(--history-accent);
  outline-offset: 2px;
}

.nf-history-drawer button:not(:disabled):hover {
  background: var(--history-selected);
}

.nf-history-drawer h2, .nf-history-drawer h3, .nf-history-drawer p {
  margin: 0;
}

.nf-history-header {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 16px;
  border-bottom: 1px solid var(--history-border);
}

.nf-history-header h2 {
  font-size: 16px;
  font-weight: 700;
}

.nf-history-header p {
  margin-top: 4px;
  color: var(--history-muted);
  font-size: 12px;
  line-height: 1.5;
}

.nf-history-drawer .nf-history-close {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 32px;
  padding: 6px;
}

.nf-history-close svg {
  width: 18px;
  height: 18px;
}

.nf-history-content {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
}

.nf-history-search {
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
  padding: 12px 14px 8px;
}

.nf-history-search button {
  flex: 0 0 auto;
  white-space: nowrap;
}

.nf-history-search input {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
  height: 34px;
  border: 1px solid var(--history-border);
  border-radius: 9px;
  padding: 7px 10px;
  color: var(--history-text);
  background: var(--history-bg);
}

.nf-history-search input::placeholder {
  color: var(--history-muted);
}

.nf-history-toolbar {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 14px 10px;
}

.nf-history-drawer .nf-history-primary {
  background: #163d6b;
  color: #fff;
  border-color: #163d6b;
}

.nf-history-drawer .nf-history-primary:not(:disabled):hover {
  background: #24548e;
}

.nf-history-drawer .nf-history-danger {
  color: var(--history-error);
}

.nf-history-drawer .nf-history-primary.nf-history-danger {
  background: #b42318;
  color: #fff;
  border-color: #b42318;
}

.nf-history-error, .nf-history-notice {
  flex: 0 0 auto;
  margin: 0 14px 8px !important;
  padding: 9px 10px;
  border: 1px solid var(--history-border);
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.6;
  overflow-wrap: anywhere;
}

.nf-history-error {
  color: var(--history-error);
}

.nf-history-notice {
  color: var(--history-accent);
}

.nf-history-health {
  flex: 0 0 auto;
  margin: 0 14px 8px;
  padding: 9px 10px;
  background: var(--history-surface);
  border: 1px solid var(--history-border);
  border-radius: 8px;
  font-size: 11px;
}

.nf-history-health > div:first-child {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

.nf-history-health.is-error {
  color: var(--history-error);
}

.nf-history-health p {
  margin-top: 6px;
  line-height: 1.6;
}

.nf-history-health small {
  display: block;
  margin-top: 4px;
  color: var(--history-muted);
}

.nf-history-health button {
  min-height: 26px;
  padding: 3px 6px;
  font-size: 11px;
}

.nf-history-recovery-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-top: 7px;
}

.nf-history-list {
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  overscroll-behavior: contain;
  padding: 0 14px 12px;
}

.nf-history-status, .nf-history-empty {
  padding: 20px 8px;
  text-align: center;
  color: var(--history-muted);
}

.nf-history-item {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 7px;
  background: var(--history-surface);
  border: 1px solid var(--history-border);
  border-radius: 10px;
  overflow: hidden;
}

.nf-history-item.is-selected {
  border-color: var(--history-accent);
  background: var(--history-selected);
}

.nf-history-drawer .nf-history-restore {
  display: block;
  flex: 1 1 auto;
  min-width: 0;
  border: 0;
  padding: 10px 8px 10px 10px;
  text-align: left;
  background: transparent;
}

.nf-history-restore strong {
  display: block;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.nf-history-restore span {
  display: block;
  margin-top: 4px;
  font-size: 11px;
  color: var(--history-muted);
  overflow-wrap: anywhere;
}

.nf-history-restore p {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1.5;
  color: var(--history-muted);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: anywhere;
}

.nf-history-drawer .nf-history-delete {
  flex: 0 0 auto;
  min-height: 28px;
  margin-right: 8px;
  padding: 4px 7px;
  font-size: 11px;
  color: var(--history-error);
}

.nf-history-drawer .nf-history-more {
  width: 100%;
  margin-top: 4px;
}

.nf-history-pagination {
  flex: 0 0 auto;
  padding: 7px 14px 10px;
  text-align: center;
  font-size: 11px;
  color: var(--history-muted);
  border-top: 1px solid var(--history-border);
}

.nf-history-confirmation-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(15, 23, 42, 0.35);
}

.nf-history-confirmation {
  width: 100%;
  max-width: 328px;
  padding: 18px;
  border: 1px solid var(--history-border);
  border-radius: 12px;
  background: var(--history-bg);
  box-shadow: 0 12px 32px rgba(15, 23, 42, 0.2);
}

.nf-history-confirmation h3 {
  font-size: 15px;
  font-weight: 700;
}

.nf-history-confirmation > p {
  margin-top: 10px;
  line-height: 1.7;
}

.nf-history-confirmation > div {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 7px;
  margin-top: 16px;
}

.nf-history-confirmation .nf-history-error {
  margin: 10px 0 0 !important;
}

@media (max-width: 480px) {
  .nf-history-drawer {
    width: 100%;
    border-left: 0;
    box-shadow: none;
  }
  .nf-history-header {
    padding: 14px;
  }
}
@media (max-height: 520px) {
  .nf-history-header {
    padding: 10px 14px;
  }
  .nf-history-header p {
    display: none;
  }
  .nf-history-content {
    overflow-y: auto;
  }
  .nf-history-search {
    padding-top: 8px;
  }
  .nf-history-toolbar {
    padding-bottom: 8px;
  }
  .nf-history-list {
    flex: 1 0 70px;
  }
  .nf-history-confirmation-overlay {
    overflow-y: auto;
    align-items: safe center;
  }
  .nf-history-confirmation {
    padding: 12px;
  }
}
.nf-chatbot-root.is-scenario-main {
  overflow: hidden;
  background: #f7f8fa;
}

.is-scenario-main .nf-chatbot-content {
  height: 0;
}

.is-scenario-main .nf-history-overlay {
  z-index: 100;
}

.nf-scenario-main {
  height: 100%;
  overflow: auto;
}

.nf-scenario-caption {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px 18px;
  padding: 10px 20px;
  background: #fff;
  color: #162f54;
  border-bottom: 1px solid #e5e9f0;
  font-size: 13px;
}

.nf-scenario-caption span {
  color: #64748b;
  font-size: 12px;
}

.nf-scenario-image {
  display: block;
  width: 100%;
  height: auto;
}

.nf-scenario-start {
  padding: 80px 32px;
  color: #162f54;
}

.nf-scenario-start h1 {
  margin: 0 0 14px;
  font-size: 28px;
}

.nf-scenario-start p {
  color: #64748b;
}

.nf-bridge-status {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  margin: 0;
  padding: 12px;
  background: #fff;
  color: #b42318;
}

@media (max-width: 600px) {
  .nf-scenario-main .nf-scenario-image {
    min-width: 900px;
  }
  .nf-scenario-caption {
    padding: 10px 14px;
  }
  .nf-scenario-start {
    padding: 50px 20px;
  }
}`],
})
export class PageChatbotComponent implements AfterViewInit, OnDestroy {
    @ViewChild('chat') public chat: any;
    @ViewChild('historyDrawer') private historyDrawer: ElementRef<HTMLElement>;
    public chatSession = chatSession;
    public embedded = window.parent !== window;
    public desktop = new URLSearchParams(location.search).get('desktop') === '1'
        && (window as any).nanofabDesktop?.enabled === true;
    public scenarioEnabled = !this.desktop && new URLSearchParams(location.search).get('scenario') === 'etch';
    public scenarioMain = this.scenarioEnabled && !this.embedded;
    public get parentControlled() {
        return this.desktop || (this.embedded && !!this.parentOrigin && /^nfcb-[0-9a-f]{32}$/.test(this.instanceId));
    }
    public scenarioScreen = 0;
    public bridgeStatus = '';
    public historyDocked = !this.embedded && !this.desktop && !this.scenarioMain && window.innerWidth >= 900;
    public historyReady = false;
    public historyOpen = this.historyDocked;
    public historyLoading = false;
    public historyBusy = false;
    public historySearch = '';
    public historyError = '';
    public historyNotice = '';
    public historyItems: any[] = [];
    public historyPagination = { page: 1, dump: 10, total: 0, totalPages: 1 };
    public historyHealth: any = null;
    public historyConfirmation: 'clear' | 'restore' | 'reset' | null = null;
    private savedUnsubscribe: (() => void) | null = null;
    private sessionUnsubscribe: (() => void) | null = null;
    private historyRequestSeq = 0;
    private historyHealthRequestSeq = 0;
    private historySavedRevision = 0;
    private historyAppliedSearch = '';
    private historyRefreshPending = false;
    private historyListController: AbortController | null = null;
    private historyRequests = new Set<AbortController>();
    private previousFocus: HTMLElement | null = null;
    private focusConversationAfterTransition = false;
    private parentOrigin = document.querySelector('meta[name="nanofab-chat-parent-origin"]')?.getAttribute('content') || '';
    private instanceId = new URLSearchParams(location.search).get('instanceId') || '';
    private readonly allowedParentOrigins = new Set((document.querySelector('meta[name="nanofab-chat-allowed-parent-origins"]')?.getAttribute('content') || '').split(',').filter(Boolean));
    private bridgeReady = false;
    private readySent = false;
    private originalHref: any;
    private readonly closeListener = () => this.send('CLOSE', {}, this.publicRequestId());
    private embedBridge: ChatEmbedBridge | null = null;
    private acceptedRequest = '';
    private publicCorrelation = '';
    private deferredScenarioQuestion: { question: string; requestId: string; step: number } | null = null;
    private screenRevision = 0;
    private screenTimer: number | null = null;
    private readonly screenLoads = new Map<number, Promise<void>>();
    private destroyed = false;

    constructor(@Inject( Service) public service: Service) {}

    public async ngAfterViewInit() {
        if (this.embedded && new URLSearchParams(location.search).has('parentOrigin')) this.startSdkBridge();
        if (this.scenarioMain) {
            for (const screen of Object.keys(ETCH_SCENARIO_SCREENS)) void this.loadScenarioScreen(Number(screen));
        }
        await this.service.init();
        if (this.destroyed) return;
        const actorId = this.service.auth.status === true ? String(this.service.auth.session?.id || '') : '';
        await chatSession.initialize(actorId, this.service.auth.session?.chat_csrf || '');
        if (this.destroyed) return;
        this.historyReady = !!actorId;
        if (!actorId) { this.historyOpen = false; this.historyError = '반디 로그인 후 대화 이력을 이용할 수 있습니다.'; }
        this.savedUnsubscribe = chatSession.subscribeSaved(() => {
            this.historySavedRevision++;
            this.historyRefreshPending = true;
            if (this.historyOpen && !this.historyBusy && !this.historyLoading) void this.loadHistory(true);
        });
        this.sessionUnsubscribe = chatSession.subscribe((snapshot, origin) => {
            if (this.destroyed) return;
            if (this.scenarioMain && origin !== this.chat) void this.restoreScenarioScreen(snapshot);
            void this.service.render();
        });
        this.embedBridge?.settle(this.service.auth.status === true);
        if (this.scenarioMain) await this.restoreScenarioScreen(chatSession.current);
        await this.service.render();
        if (!this.embedded) {
            if (this.historyOpen) void this.loadHistory(true);
            return;
        }
        this.originalHref = this.service.href;
        this.service.href = (path: any) => {
            if (typeof path !== 'string' || path.length > 2048) return;
            try {
                const url = new URL(path, this.parentOrigin);
                if (url.origin !== this.parentOrigin || url.username || url.password || url.hash) return;
                if (!/^\/agent\/[a-z0-9_-]+$/.test(url.pathname)
                    && !['/access', '/dashboard', '/dashboard2', '/knowledge/document-results'].includes(url.pathname)) return;
                this.send('NAVIGATE', { path: url.pathname + url.search });
            } catch (_) {}
        };
        window.addEventListener('nanofab-embedded-close', this.closeListener);
        this.bridgeReady = true;
        this.announceReady();
        if (this.historyOpen) void this.loadHistory(true);
    }

    @HostListener('window:nanofab-auth-changed')
    public async authenticationChanged() {
        if (this.destroyed) return;
        const authenticated = this.service.auth.status === true;
        this.historyRequestSeq++;
        this.historyHealthRequestSeq++;
        for (const request of this.historyRequests) request.abort();
        this.historyRequests.clear();
        this.historyItems = [];
        this.historyHealth = null;
        this.historyConfirmation = null;
        this.historyReady = authenticated;
        this.historyOpen = false;
        this.historyError = authenticated ? '' : '반디 로그인 후 대화 이력을 이용할 수 있습니다.';
        this.acceptedRequest = '';
        this.publicCorrelation = '';
        this.deferredScenarioQuestion = null;
        this.cancelScreenTransition();
        await chatSession.initialize(
            authenticated ? this.service.auth.session.id : '',
            authenticated ? this.service.auth.session.chat_csrf : ''
        );
        this.embedBridge?.settle(authenticated);
        if (!authenticated && !this.embedBridge) {
            this.send('ERROR', { code: 'PLATFORM_LOGIN_REQUIRED', message: '반디 로그인이 필요합니다.', retryable: true }, this.publicRequestId());
        }
        await this.service.render();
    }

    public ngOnDestroy() {
        this.destroyed = true;
        this.deferredScenarioQuestion = null;
        this.cancelScreenTransition();
        this.embedBridge?.destroy();
        this.historyRequestSeq++;
        this.historyHealthRequestSeq++;
        this.savedUnsubscribe?.();
        this.sessionUnsubscribe?.();
        for (const controller of this.historyRequests) controller.abort();
        this.historyRequests.clear();
        this.previousFocus = null;
        window.removeEventListener('nanofab-embedded-close', this.closeListener);
        if (this.originalHref) this.service.href = this.originalHref;
    }

    public get historyModal() { return this.historyOpen && !this.historyDocked; }

    public async toggleHistoryDrawer() {
        if (this.historyOpen) await this.closeHistoryDrawer();
        else await this.openHistoryDrawer();
    }

    @HostListener('window:resize')
    public async handleHistoryViewportChange() {
        const docked = !this.embedded && !this.desktop && !this.scenarioMain && window.innerWidth >= 900;
        if (this.destroyed || docked === this.historyDocked) return;
        const focusedInHistory = this.historyDrawer?.nativeElement.contains(document.activeElement);
        this.historyDocked = docked;
        this.historyOpen = this.historyReady && (docked || !!this.historyConfirmation);
        this.previousFocus = null;
        await this.service.render();
        if (!this.historyOpen && focusedInHistory) this.focusHistoryTrigger();
        if (this.historyOpen && this.historyReady) void this.loadHistory(true);
    }

    public async openHistoryDrawer() {
        if (this.destroyed || this.historyBusy || !this.historyReady) return;
        this.previousFocus = !this.historyDocked && document.activeElement instanceof HTMLElement ? document.activeElement : null;
        this.historyOpen = true;
        this.historyNotice = '';
        await this.service.render();
        this.historyDrawer?.nativeElement.querySelector<HTMLInputElement>('input')?.focus();
        await this.loadHistory(true);
    }

    public async closeHistoryDrawer() {
        if (this.historyBusy) return;
        this.historyOpen = false;
        this.historyConfirmation = null;
        await this.service.render();
        if (this.previousFocus?.isConnected) this.previousFocus.focus();
        else this.focusHistoryTrigger();
        this.previousFocus = null;
    }

    public async searchHistory() {
        if (this.historyBusy) return;
        this.historyAppliedSearch = this.historySearch.trim().slice(0, 240);
        this.historyRefreshPending = true;
        await this.loadHistory(true);
    }

    public hasMoreHistory() {
        return this.historyPagination.page < this.historyPagination.totalPages;
    }

    public async loadMoreHistory() {
        if (!this.hasMoreHistory() || this.historyBusy || this.historyLoading) return;
        await this.loadHistory(false);
    }

    public async loadHistory(reset: boolean = true) {
        if (this.destroyed || !this.historyReady || this.historyBusy) return;
        if (this.historyLoading) {
            if (reset) this.historyRefreshPending = true;
            return;
        }
        this.historyRefreshPending = false;
        const requestSeq = ++this.historyRequestSeq;
        const savedRevision = this.historySavedRevision;
        const search = this.historyAppliedSearch;
        const page = reset ? 1 : this.historyPagination.page + 1;
        const controller = new AbortController();
        this.historyListController = controller;
        this.historyLoading = true;
        this.historyError = '';
        await this.service.render();
        try {
            const result = await this.historyApi('load_history', { page, dump: 10, search }, controller);
            if (this.destroyed || requestSeq !== this.historyRequestSeq) return;
            if (savedRevision !== this.historySavedRevision || search !== this.historyAppliedSearch) {
                this.historyRefreshPending = true;
                return;
            }
            const items = Array.isArray(result?.items) ? result.items : [];
            const seen = new Set<string>();
            this.historyItems = (reset ? items : [...this.historyItems, ...items]).filter(item => {
                const id = String(item?.id || '');
                if (!id || seen.has(id)) return false;
                seen.add(id);
                return true;
            });
            this.historyPagination = result.pagination || { page, dump: 10, total: items.length, totalPages: 1 };
            this.historyHealth = result.health || this.historyHealth;
        } catch (error: any) {
            if (!this.destroyed && requestSeq === this.historyRequestSeq && error?.name !== 'AbortError'
                && savedRevision === this.historySavedRevision && search === this.historyAppliedSearch) {
                this.historyError = this.errorText(error, '대화 이력을 불러오지 못했습니다.');
                await this.loadHistoryHealth(false);
            } else if (!this.destroyed && requestSeq === this.historyRequestSeq && error?.name !== 'AbortError') {
                this.historyRefreshPending = true;
            }
        } finally {
            if (this.historyListController === controller) this.historyListController = null;
            if (!this.destroyed && requestSeq === this.historyRequestSeq) {
                this.historyLoading = false;
                await this.service.render();
                if (this.historyRefreshPending && this.historyOpen && !this.historyBusy) void this.loadHistory(true);
            }
        }
    }

    public async restoreHistoryItem(item: any) {
        const id = String(item?.id || '');
        if (!id) return;
        await this.runHistoryAction(async () => {
            await this.checkpointCurrentConversation();
            // Always read the full, current server snapshot; list rows are summaries.
            const result = await this.historyApi('load_history_item', { id });
            if (this.destroyed) return;
            if (String(result?.item?.id || '') !== id || !Array.isArray(result?.item?.messages)) {
                throw new Error('대화 내용의 형식을 확인하지 못했습니다. 다시 불러와 주세요.');
            }
            chatSession.activate(result.item);
            this.historyOpen = this.historyDocked;
            this.focusConversationAfterTransition = true;
        });
    }

    public async startNewConversation() {
        await this.runHistoryAction(async () => {
            await this.checkpointCurrentConversation();
            if (this.destroyed) return;
            chatSession.newConversation();
            this.historyOpen = this.historyDocked;
            this.focusConversationAfterTransition = true;
        });
    }

    public async deleteHistoryItem(item: any, event?: Event) {
        event?.preventDefault();
        event?.stopPropagation();
        const id = String(item?.id || '');
        if (!id) return;
        await this.runHistoryAction(async () => {
            // Lock the chat and drain every save so deletion cannot be undone by an older write.
            await this.checkpointCurrentConversation();
            await this.historyApi('delete_history_item', { id });
            if (this.destroyed) return;
            chatSession.remove(id);
            this.historyItems = this.historyItems.filter(row => String(row.id) !== id);
            this.historyNotice = '대화 이력을 삭제했습니다.';
        });
    }

    public async requestHistoryConfirmation(kind: 'clear' | 'restore' | 'reset') {
        if (this.historyBusy || (kind === 'restore' && !this.latestHistoryBackup())) return;
        this.historyConfirmation = kind;
        await this.service.render();
        this.historyDrawer?.nativeElement.querySelector<HTMLElement>('.nf-history-confirmation button')?.focus();
    }

    public async cancelHistoryConfirmation() {
        if (this.historyBusy) return;
        this.historyConfirmation = null;
        await this.service.render();
        this.historyDrawer?.nativeElement.querySelector<HTMLInputElement>('input')?.focus();
    }

    public async confirmHistoryAction() {
        const kind = this.historyConfirmation;
        if (!kind) return;
        await this.runHistoryAction(async () => {
            if (kind === 'clear') {
                await this.checkpointCurrentConversation();
                await this.historyApi('delete_history', {});
                if (this.destroyed) return;
                chatSession.remove();
                this.historyItems = [];
                this.historyNotice = '전체 대화 이력을 삭제했습니다.';
            } else {
                const backup = this.latestHistoryBackup();
                if (kind === 'restore' && !backup) throw new Error('복원할 검증 백업이 없습니다.');
                // A corrupt store rejects checkpoints. Keep the local snapshot and stop transports before recovery.
                try { await this.checkpointCurrentConversation(); }
                catch (error) { if (!chatSession.error) throw error; }
                await chatSession.flush();
                const result = await this.historyApi('history_recover', {
                    action: kind === 'reset' ? 'reset' : 'restore',
                    backup_id: kind === 'reset' ? '' : backup.id,
                    confirmation: kind === 'reset' ? 'RESET CORRUPT HISTORY' : 'RESTORE HISTORY'
                });
                if (this.destroyed) return;
                this.historyHealth = result.health || this.historyHealth;
                chatSession.activate(chatSession.current);
                this.historyNotice = kind === 'reset'
                    ? '손상 이력을 격리하고 초기화했습니다. 현재 대화는 브라우저에 유지됩니다.'
                    : '검증 백업을 복원했습니다. 현재 대화는 브라우저에 유지됩니다.';
            }
            this.historyConfirmation = null;
        });
    }

    public latestHistoryBackup() { return (this.historyHealth?.backups || [])[0] || null; }

    public historyHealthLabel() {
        const labels: any = { healthy: '서버 이력 정상', empty: '서버 이력 비어 있음', corrupt: '이력 파일 손상', oversized: '이력 파일 크기 초과', unavailable: '상태 확인 실패' };
        return labels[this.historyHealth?.status] || '이력 상태 확인 중';
    }

    public async loadHistoryHealth(render: boolean = true) {
        if (this.destroyed || !this.historyReady) return;
        const requestSeq = ++this.historyHealthRequestSeq;
        try {
            const health = await this.historyApi('history_health', {});
            if (!this.destroyed && requestSeq === this.historyHealthRequestSeq) this.historyHealth = health;
        } catch (error: any) {
            if (!this.destroyed && requestSeq === this.historyHealthRequestSeq && error?.name !== 'AbortError') this.historyHealth = { status: 'unavailable', healthy: false, backups: [], message: this.errorText(error, '서버 이력 상태를 확인하지 못했습니다.') };
        }
        if (!this.destroyed && render) await this.service.render();
    }

    private async checkpointCurrentConversation() {
        if (!this.chat?.checkpointConversation) throw new Error('대화가 준비 중입니다. 잠시 후 다시 시도해 주세요.');
        if (!await this.chat.checkpointConversation()) throw new Error(chatSession.error || '대화 준비가 끝나지 않았습니다. 잠시 후 다시 시도해 주세요.');
        await chatSession.flush();
        if (this.destroyed) throw new Error('대화 화면이 종료되었습니다.');
    }

    private async runHistoryAction(action: () => Promise<void>) {
        if (this.destroyed || this.historyBusy || !this.historyReady) return;
        this.historyBusy = true;
        this.historyError = '';
        this.historyNotice = '';
        this.historyRequestSeq++;
        this.historyHealthRequestSeq++;
        this.historyListController?.abort();
        this.historyLoading = false;
        await this.service.render();
        try {
            await action();
        } catch (error: any) {
            if (!this.destroyed && error?.name !== 'AbortError') this.historyError = this.errorText(error, '대화 이력을 처리하지 못했습니다.');
        } finally {
            if (!this.destroyed) {
                this.historyBusy = false;
                this.historyRefreshPending = true;
                await this.service.render();
                if (this.historyOpen && !this.historyError) await this.loadHistory(true);
                if (this.focusConversationAfterTransition) {
                    document.querySelector<HTMLElement>('wiz-portal-fab-chat [aria-label="플로팅 AI 질문 입력"]')?.focus();
                    this.focusConversationAfterTransition = false;
                    this.previousFocus = null;
                } else if (this.historyOpen && document.activeElement === document.body) {
                    this.historyDrawer?.nativeElement.querySelector<HTMLInputElement>('input')?.focus();
                } else if (!this.historyOpen) {
                    if (this.previousFocus?.isConnected) this.previousFocus.focus();
                    this.previousFocus = null;
                }
            }
        }
    }

    private async historyApi(action: string, params: any, controller = new AbortController()): Promise<any> {
        if (this.service.auth.status !== true) throw new Error('반디 로그인이 필요합니다.');
        this.historyRequests.add(controller);
        const body = new URLSearchParams();
        for (const key of Object.keys(params || {})) body.set(key, String(params[key] ?? ''));
        const csrf = this.service.auth.session?.chat_csrf;
        if (csrf) body.set('chat_csrf_token', String(csrf));
        try {
            const response = await fetch(agentApiPath('/wiz/api/page.agent/') + action, { method: 'POST', body, credentials: 'same-origin', signal: controller.signal });
            if (response.status === 401) this.service.auth.invalidate();
            let payload = await response.json();
            const status = response.ok ? Number(payload?.code || 200) : response.status;
            const code = payload?.data?.error?.code || payload?.error?.code;
            if ((status === 401 && response.status !== 401) || (status === 403 && code === 'CHAT_CSRF_INVALID')) {
                this.service.auth.invalidate();
            }
            if (!response.ok) throw new Error(this.apiError(payload));
            for (let depth = 0; depth < 4; depth++) {
                if (payload?.code !== undefined && Number(payload.code) !== 200) throw new Error(this.apiError(payload));
                if (!payload || typeof payload !== 'object' || payload.data === undefined) break;
                payload = payload.data;
            }
            return payload || {};
        } finally { this.historyRequests.delete(controller); }
    }

    private apiError(payload: any) {
        return String(payload?.data?.error?.message || payload?.data?.data?.error?.message || payload?.error?.message || payload?.data?.message || payload?.message || '서버 이력 요청을 처리하지 못했습니다.');
    }

    private errorText(error: any, fallback: string) { return String(error?.message || fallback); }

    private focusHistoryTrigger() {
        document.querySelector<HTMLElement>('wiz-portal-fab-chat .nf-floating-chat-history-trigger')?.focus();
    }

    @HostListener('document:keydown', ['$event'])
    public handleHistoryKeydown(event: KeyboardEvent) {
        if (!this.historyOpen) return;
        const dialog = this.historyDrawer?.nativeElement;
        if (!this.historyModal && !this.historyConfirmation) {
            if (event.key === 'Escape' && dialog?.contains(document.activeElement)) {
                event.preventDefault();
                void this.closeHistoryDrawer();
            }
            return;
        }
        if (event.key === 'Escape') {
            event.preventDefault();
            if (this.historyConfirmation) void this.cancelHistoryConfirmation();
            else void this.closeHistoryDrawer();
            return;
        }
        if (event.key !== 'Tab') return;
        if (!dialog) return;
        const scope = this.historyConfirmation ? dialog.querySelector<HTMLElement>('.nf-history-confirmation') || dialog : dialog;
        const elements = Array.from(scope.querySelectorAll<HTMLElement>('button:not([disabled]), input:not([disabled]), [tabindex="0"]')).filter(node => node.getClientRects().length > 0);
        if (!elements.length) { event.preventDefault(); dialog.focus(); return; }
        const first = elements[0], last = elements[elements.length - 1];
        if (event.shiftKey && (document.activeElement === first || !scope.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || !scope.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
    }

    public get scenarioImage() { return ETCH_SCENARIO_SCREENS[this.scenarioScreen] || null; }

    private publicRequestId() {
        const bytes = new Uint8Array(16);
        window.crypto.getRandomValues(bytes);
        return 'req-' + Array.from(bytes).map(value => value.toString(16).padStart(2, '0')).join('');
    }

    private startSdkBridge() {
        this.embedBridge = new ChatEmbedBridge({
            query: async query => {
                if (!this.chat?.submitQuestion) throw new Error('챗봇 준비 중');
                await this.chat.submitQuestion(query);
            },
            reset: async () => { await this.chat?.resetFloatingChat(); },
            busy: () => this.historyBusy || !this.chat
                || this.chat.floatingChatAsking || this.chat.hasPendingFloatingIntentReview(),
            changed: message => { this.bridgeStatus = message; if (!this.destroyed) void this.service.render(); }
        });
        this.embedBridge.start();
    }

    public onQuestionSubmitted(value: any) {
        if (this.destroyed || typeof value?.question !== 'string' || typeof value?.requestId !== 'string'
            || !/^req-[0-9a-f]{32}$/.test(value.requestId)) return;
        this.acceptedRequest = value.requestId;
        this.publicCorrelation = this.embedBridge?.questionSubmitted(value.question, value.requestId) || value.requestId;
        this.cancelScreenTransition();
        const payload = { question: value.question.slice(0, 2000), requestId: this.publicCorrelation };
        // The parent prepares its selected scenes and decides when to apply the completed answer.
        this.deferredScenarioQuestion = null;
        window.dispatchEvent(new CustomEvent('nanofab:chatbot-query', { detail: payload }));
        if (this.desktop && !this.destroyed && this.acceptedRequest === value.requestId) {
            window.dispatchEvent(new CustomEvent('nanofab:desktop-query', { detail: payload }));
        }
        if (!this.embedBridge) this.send('QUERY_SUBMITTED', payload, payload.requestId);
    }

    public async onAnswerCompleted(value: any) {
        if (this.destroyed || value?.requestId !== this.acceptedRequest) return;
        const payload = publicFloatingChatCompletion(value);
        if (!payload) return;
        const desktopPayload = this.desktop ? publicDesktopChatCompletion(value) : null;
        this.acceptedRequest = '';
        this.deferredScenarioQuestion = null;
        const revision = this.screenRevision;
        payload.requestId = this.publicCorrelation || payload.requestId;
        if (this.embedBridge) this.embedBridge.result(payload);
        else this.send('RESULT', payload, payload.requestId);
        window.dispatchEvent(new CustomEvent('nanofab:chatbot-result', { detail: payload }));
        if (desktopPayload && !this.destroyed && revision === this.screenRevision) {
            desktopPayload.requestId = payload.requestId;
            window.dispatchEvent(new CustomEvent('nanofab:desktop-result', { detail: desktopPayload }));
        }
        if (!this.destroyed && revision === this.screenRevision && this.scenarioMain && payload.scenario?.id === ETCH_SCENARIO_ID) {
            await this.showScenarioSequence(payload.scenario.screenSequence, payload.requestId);
        }
    }

    public async onConversationReset() {
        if (this.destroyed) return;
        this.acceptedRequest = '';
        this.publicCorrelation = '';
        this.deferredScenarioQuestion = null;
        this.embedBridge?.cancelPending();
        this.cancelScreenTransition();
        this.scenarioScreen = 0;
        const revision = this.screenRevision;
        const snapshot = chatSession.current;
        const requestId = this.publicRequestId();
        window.dispatchEvent(new CustomEvent('nanofab:chatbot-reset', { detail: { requestId } }));
        if (this.desktop) window.dispatchEvent(new CustomEvent('nanofab:desktop-reset', { detail: { requestId } }));
        this.send('CONVERSATION_RESET', {}, requestId);
        await this.service.render();
        // A history activation also resets the child. Restore the selected
        // snapshot regardless of which session subscriber runs first.
        if (!this.destroyed && this.scenarioMain && revision === this.screenRevision) {
            await this.restoreScenarioScreen(snapshot);
        }
    }

    private cancelScreenTransition() {
        this.screenRevision++;
        if (this.screenTimer !== null) window.clearTimeout(this.screenTimer);
        this.screenTimer = null;
    }

    private loadScenarioScreen(screen: number) {
        if (!ETCH_SCENARIO_SCREENS[screen]) return Promise.resolve();
        if (!this.screenLoads.has(screen)) {
            const ready = new Promise<void>(resolve => {
                const image = new Image();
                image.onload = () => resolve();
                image.onerror = () => resolve();
                image.src = ETCH_SCENARIO_SCREENS[screen].src;
            });
            this.screenLoads.set(screen, ready);
        }
        return this.screenLoads.get(screen)!;
    }

    private async showScenarioSequence(screens: number[], requestId: string) {
        this.cancelScreenTransition();
        const revision = this.screenRevision;
        const show = async (index: number) => {
            const screen = screens[index];
            if (!ETCH_SCENARIO_SCREENS[screen]) return;
            await this.loadScenarioScreen(screen);
            if (this.destroyed || revision !== this.screenRevision) return;
            this.scenarioScreen = screen;
            await this.service.render();
            if (this.destroyed || revision !== this.screenRevision) return;
            window.dispatchEvent(new CustomEvent('nanofab:chatbot-screen', {
                detail: { screen, requestId, referenceLabel: ETCH_SCENARIO_SCREENS[screen].label }
            }));
            if (index + 1 < screens.length) {
                this.screenTimer = window.setTimeout(() => {
                    this.screenTimer = null;
                    void show(index + 1);
                }, 750);
            }
        };
        await show(0);
    }

    private async restoreScenarioScreen(snapshot: any) {
        this.acceptedRequest = '';
        this.publicCorrelation = '';
        this.deferredScenarioQuestion = null;
        this.cancelScreenTransition();
        const revision = this.screenRevision;
        const messages = Array.isArray(snapshot?.messages) ? snapshot.messages : [];
        const latest = [...messages].reverse().find(message => message?.role === 'assistant'
            && !message.processing && !message.streaming && !message.cancelled && !message.intentReview
            && typeof message.content === 'string' && message.content.trim());
        const step = latest?.scenario?.id === ETCH_SCENARIO_ID ? latest.scenario.step : 0;
        const screen = step === 3 ? 4 : step === 4 ? 7 : step === 1 || step === 2 ? step : 0;
        if (screen) await this.loadScenarioScreen(screen);
        if (!this.destroyed && revision === this.screenRevision) { this.scenarioScreen = screen; await this.service.render(); }
    }

    private send(type: string, payload: any, requestId: string | null = null) {
        if (!this.embedded || !this.parentOrigin || !/^nfcb-[0-9a-f]{32}$/.test(this.instanceId)) return;
        window.parent.postMessage({ channel: CHANNEL, version: 1, type, requestId, instanceId: this.instanceId, payload }, this.parentOrigin);
    }

    private announceReady() {
        if (this.embedBridge || this.readySent || !this.bridgeReady || !this.parentOrigin || !/^nfcb-[0-9a-f]{32}$/.test(this.instanceId)) return;
        this.readySent = true;
        this.send('READY', { authenticated: this.service.auth?.status === true });
        if (this.service.auth?.status !== true) {
            this.send('ERROR', { code: 'PLATFORM_LOGIN_REQUIRED', message: '반디 로그인이 필요합니다.', retryable: true }, this.publicRequestId());
        }
    }

    private plainObject(value: any) {
        if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
        const prototype = Object.getPrototypeOf(value);
        return prototype === Object.prototype || prototype === null;
    }

    private validHostContext(value: any) {
        try {
            if (!this.plainObject(value)
                || Object.keys(value).some(key => !['channel', 'version', 'type', 'requestId', 'instanceId', 'payload'].includes(key))
                || value.channel !== CHANNEL || value.version !== 1 || value.type !== 'HOST_CONTEXT'
                || typeof value.instanceId !== 'string' || !/^nfcb-[0-9a-f]{32}$/.test(value.instanceId)
                || (value.requestId != null && (typeof value.requestId !== 'string' || !/^req-[0-9a-f]{32}$/.test(value.requestId)))
                || !this.plainObject(value.payload) || Object.keys(value.payload).some(key => key !== 'context')
                || !this.plainObject(value.payload.context)
                || Object.keys(value.payload.context).some(key => !['theme', 'path', 'title'].includes(key))
                || new TextEncoder().encode(JSON.stringify(value)).length > 65536) return false;
            const context = value.payload.context;
            return (context.theme === 'dark' || context.theme === 'light')
                && typeof context.path === 'string' && context.path.length <= 300
                && typeof context.title === 'string' && context.title.length <= 300;
        } catch (_) { return false; }
    }

    @HostListener('window:message', ['$event'])
    public receiveMessage(event: MessageEvent) {
        const value = event.data;
        let shouldRender = false;
        if (this.destroyed || !this.embedded || event.source !== window.parent
            || !this.allowedParentOrigins.has(event.origin) || !this.validHostContext(value)) return;
        if (!this.parentOrigin && !this.instanceId) {
            this.parentOrigin = event.origin;
            this.instanceId = value.instanceId;
            shouldRender = true;
        }
        if (event.origin !== this.parentOrigin || value.instanceId !== this.instanceId) return;
        // The search main belongs to nano; this iframe only provides its answers.
        if (event.origin === 'https://nano.wizide.com'
            && new URLSearchParams(location.search).get('view') !== 'chat') {
            this.scenarioEnabled = true;
            shouldRender = true;
        }
        const theme = value.payload.context.theme;
        document.documentElement.setAttribute('data-theme', theme);
        document.documentElement.style.colorScheme = theme;
        if (shouldRender && this.bridgeReady) void this.service.render();
        this.announceReady();
    }
}

/**
 * Preserve standalone WIZ APIs while supporting BANDI /agent/ proxy.
 */
function agentApiPath(path: string): string {
    if (!path.startsWith('/wiz/api/')) {
        throw new Error('Unexpected agent API path');
    }

    if (typeof window === 'undefined') {
        return path;
    }

    const pathname = window.location.pathname || '';
    const embeddedOnBandi =
        pathname === '/agent' ||
        pathname.startsWith('/agent/');

    return embeddedOnBandi ? '/agent' + path : path;
}

export default PageChatbotComponent;